/** Respuestas de la capacitación Takis del 9-oct. Se guardan como texto legible en
 * ejecucion_comentario, que ya leen y auditan el celular, la oficina y los reportes.
 * Así no dependen de una columna nueva ni se pierden al corregir un cierre. */
export const CABECERA_TAKIS = 'Degustación y promoción Takis';
const OBSERVACIONES = '\n\nObservaciones de tienda:\n';
export const PREGUNTAS_TAKIS = [
  { campo: 'degustacion', label: '¿Qué sabores diste a degustar hoy?', resumen: 'Sabores degustados', opciones: [
    ['ambos', 'Intense Nacho y Ranch'], ['nacho', 'Solo Intense Nacho'],
    ['ranch', 'Solo Ranch'], ['no', 'No pude realizar degustación'],
  ] },
  { campo: 'limite', label: '¿Qué limitó la degustación hoy?', resumen: 'Limitación de degustación', opciones: [
    ['no', 'Nada; pude degustar durante la jornada'], ['producto', 'Faltó producto para degustar'],
    ['vasitos', 'Faltaron vasitos o materiales'], ['permiso', 'La tienda no permitió degustar'],
    ['sin_muestras', 'No recibí muestras'], ['otro', 'Otro motivo'],
  ] },
  { campo: 'preferencia', label: '¿Cuál de los sabores sin picante tuvo mejor aceptación?', resumen: 'Aceptación de sabores', opciones: [
    ['nacho', 'Intense Nacho'], ['ranch', 'Ranch'], ['ambos', 'Ambos por igual'],
    ['no_se', 'No pude distinguirlo'], ['no', 'No probó ninguno / no hubo degustación'],
  ] },
  { campo: 'conteo_personas', label: '¿Cómo obtuviste el número de personas que degustaron?', resumen: 'Tipo de conteo de personas', opciones: [
    ['contado', 'Llevé un conteo de personas'], ['estimado', 'Es una estimación al terminar'],
    ['no_conte', 'No llevé el conteo / no puedo estimarlo'],
  ] },
  { campo: 'fanta', label: '¿La promoción con Fanta se podía aplicar en tu tienda?', resumen: 'Promoción con Fanta', opciones: [
    ['si', 'Sí, verifiqué que se podía aplicar'], ['no', 'Estaba anunciada, pero no se podía aplicar'],
    ['no_aplica', 'No estaba disponible en esta tienda'], ['no_se', 'No pude verificarlo'],
  ] },
  { campo: 'ubicacion', label: '¿Había Takis junto a bebidas, Fanta o cajas?', resumen: 'Ubicación junto a bebidas o cajas', opciones: [
    ['ambos', 'En bebidas y en cajas'], ['bebidas', 'Solo en bebidas / junto a Fanta'],
    ['cajas', 'Solo en cajas'], ['no', 'No había en esas zonas'], ['no_se', 'No pude verificarlo'],
  ] },
  { campo: 'mercaderista', label: '¿Tuviste apoyo para reponer o ubicar Takis?', resumen: 'Apoyo de reposición', opciones: [
    ['bimbo', 'Sí, del mercaderista de Bimbo'], ['tienda', 'Sí, del personal de la tienda'],
    ['ambos', 'Sí, de ambos'], ['no', 'No tuve apoyo'], ['no_necesite', 'No necesité apoyo'],
  ] },
] as const;
export type CampoTakis = typeof PREGUNTAS_TAKIS[number]['campo'];
export interface RespuestasTakis extends Record<CampoTakis, string> {
  personas: string;
  bolsas_nacho: string;
  bolsas_ranch: string;
  precio_ranch: string;
  detalle: string;
  observaciones: string;
}
export const TAKIS_VACIO: RespuestasTakis = {
  degustacion: '', limite: '', preferencia: '', conteo_personas: '', personas: '', fanta: '', ubicacion: '', mercaderista: '',
  bolsas_nacho: '', bolsas_ranch: '', precio_ranch: '', detalle: '', observaciones: '',
};
const adicionales = [
  ['personas', 'Personas que degustaron'],
  ['bolsas_nacho', 'Bolsas usadas de Intense Nacho'],
  ['bolsas_ranch', 'Bolsas usadas de Ranch'],
  ['precio_ranch', 'Precio de Ranch 85 g (S/)'],
  ['detalle', 'Detalle de degustación y promoción'],
] as const;

export function leerTakis(texto: string): RespuestasTakis {
  const r = { ...TAKIS_VACIO };
  if (!texto.startsWith(CABECERA_TAKIS + '\n')) return { ...r, observaciones: texto };
  const corte = texto.indexOf(OBSERVACIONES);
  const bloque = corte < 0 ? texto : texto.slice(0, corte);
  r.observaciones = corte < 0 ? '' : texto.slice(corte + OBSERVACIONES.length);
  const valor = (label: string) => bloque.split('\n').find((l) => l.startsWith(label + ': '))?.slice(label.length + 2) ?? '';
  for (const p of PREGUNTAS_TAKIS) r[p.campo] = p.opciones.find((o) => o[1] === valor(p.resumen))?.[0] ?? '';
  for (const [campo, label] of adicionales) r[campo] = valor(label);
  return r;
}

export function escribirTakis(r: RespuestasTakis): string {
  const lineas = [CABECERA_TAKIS];
  for (const p of PREGUNTAS_TAKIS) {
    const label = p.opciones.find((o) => o[0] === r[p.campo])?.[1];
    if (label) lineas.push(`${p.resumen}: ${label}`);
  }
  for (const [campo, label] of adicionales) {
    if (r[campo].trim()) lineas.push(`${label}: ${r[campo].trim().replace(/\r?\n/g, ' ')}`);
  }
  return lineas.join('\n') + OBSERVACIONES + r.observaciones;
}

export function faltaTakis(texto: string, exigirRespuestas = true): string | null {
  const r = leerTakis(texto);
  if (exigirRespuestas) {
    for (const p of PREGUNTAS_TAKIS) {
      if (!p.opciones.some((o) => o[0] === r[p.campo])) return `Falta responder: ${p.label}`;
    }
    if (r.degustacion === 'no' && r.limite === 'no') return 'Indica por qué no pudiste realizar degustación.';
    if (r.limite === 'otro' && !r.detalle.trim()) return 'Cuéntanos qué limitó la degustación.';
  }
  for (const [campo, label] of adicionales.slice(0, 3)) {
    if (r[campo].trim() && !/^\d+$/.test(r[campo].trim())) return `${label}: usa un número entero (0 si no usaste ninguna).`;
  }
  if (['contado', 'estimado'].includes(r.conteo_personas) && !r.personas.trim()) return 'Indica a cuántas personas diste degustación, o elige que no llevaste el conteo.';
  if (r.personas.trim() && !['contado', 'estimado'].includes(r.conteo_personas)) return 'Indica si la cantidad de personas fue contada o estimada.';
  if (r.degustacion === 'no' && Number(r.personas) > 0) return 'Si no hubo degustación, la cantidad de personas no puede ser mayor que cero.';
  if (r.precio_ranch.trim() && !/^\d+(\.\d{1,2})?$/.test(r.precio_ranch.trim())) return 'El precio de Ranch debe ser un número en soles.';
  return null;
}
